module.exports = __webpack_public_path__ + "img/edge_patrimoine_sciences.e7308ef4.svg";